import { values } from "lodash";
import SimpleSchema from "@inspire/data/schemas/SimpleSchema";
import { UserStatus } from "@inspire/data/static/user-status";
// Les statuts possibles des utilisateurs sur INSPIRE sont les mêmes pour
// les lycéens et les éclaireurs. Les utilisateurs ne peuvent pas avoir
// plusieurs statuts.
// Actif : c’est le statut par défaut des utilisateurs.
//
// Caché : lorsqu’un utilisateur est caché, il doit être invisible des autres
// utilisateurs, mais son accès au site n’est pas bloqué.
// Quatre profils d’éclaireurs sont
// automatiquement cachés du site (Profil incomplet,
// No piste, Déconseille bac+1, Réorienté). Pour les deux premiers cas de
// figure (Profil incomplet, No Piste), le statut n’est pas réversible. Pour
// tous les autres cas de figure, un admin peut choisir de les montrer depuis
// le backoffice.
//
// Supprimé : ces utilisateurs sont supprimés INSPIRE.
// Ils doivent être cachés des autres utilisateurs, ne doivent pas être comptés
// dans les compteurs et statistiques de l’onglet stats, et leur accès au site
// est bloqué. Ce statut n’est pas réversible.
//
// Anciens : N'apparaissent plus dans les recommendations d'éclaireur mais leur
// profil est toujours accessible via l'url
var UserStatusSchema = new SimpleSchema({
    status: {
        type: String,
        optional: true,
        defaultValue: UserStatus.active,
        allowedValues: values(UserStatus)
    }
});
export { UserStatusSchema };
